const service = function(
	$http,
	$q,
	$rootScope, 
	_,
	api, 
	Product, 
	Session, 
) {
	'ngInject'

	var Basket = this;

	this.refresh = function() {
		return $http.get(api+'/v1/basket').then(function(response) {
			Session.set('basket', response.data);
			$rootScope.$broadcast('BASKET_CHANGED');
			return $q.resolve();
		});
	}

	this.get = () => Session.get('basket', []);
	this.add = (id, data) => $http.post(api+'/v1/basket/'+id, data).then(Basket.refresh);
	this.update = (id, data) => $http.put(api+'/v1/basket/'+id, data);
	this.remove = (id) => $http.delete(api+'/v1/basket/'+id).then(Basket.refresh);
	this.clear = () => $http.delete(api+'/v1/basket').then(Basket.refresh);

	this.flush = () => {
		Session.remove('basket');
		$rootScope.$broadcast('BASKET_CHANGED');
	}

	this.count = (id) => {
		var basket = Session.get('basket');
		var result = 0;
		if (basket && basket.length > 0) {
			_.each(basket, function(product) {
				if (product.product_id == id) {
					result++;
				}
			});
		}
		return result;
	}

	this.total = () => {
		var basket = Session.get('basket');
		var result = 0;
		if (basket && basket.length > 0) {
			result = basket.length;
		}
		return result;
	}
}

export default service


// WEBPACK FOOTER //
// ./app/shared/services/basket.service.js